import * as ACTIONS from '../actions/board';
import { MOVEMENT_SPEEDS } from '../../components/Board/config';
import { WALKTHROUGH_END } from '../actions/app';

let defaultZoom;

switch( true ){
    case ( window.innerWidth < 768 ):
        defaultZoom = 0;
        break;
    default: 
        defaultZoom = 3;
        break;
}


const INITIAL_STATE = {
    dragging: false,
    isNew: true,
    name: undefined,
    nodes: {},
    connections: {},
    currentNode: {},
    nodeContextMenu: {
        anchorEl: null,
        id: null
    },
    magnifications: [],
    viewPos: {
        x: 0,
        y: 0
    },
    revision: 1,
    zoom: defaultZoom
};

const reducer = ( state=INITIAL_STATE, action ) => {

    const connections = { ...state.connections },
    nodes = { ...state.nodes },
    newId = crypto.randomUUID();

    let isNew = state.isNew;

    switch( action.type ){

        case ACTIONS.CONNECTION_ADD:
            action.payload.forEach( node => {
                nodes[ node ].connections.push( newId );
            });
            connections[ newId ] = action.payload;
            return { ...state, connections, nodes, currentNode: {} };

        case ACTIONS.CONNECTION_REMOVE:
            connections[ action.payload ].forEach( parent => {
                const index = nodes[ parent ].connections.indexOf( action.payload );
                nodes[ parent ].connections.splice( index, 1 );
            });

            delete connections[ action.payload ];

            return { ...state, connections, nodes, currentNode: {} };

        case ACTIONS.CURRENT_NODE:
            const currentNode = action.payload ? { ...nodes[ action.payload ] } : INITIAL_STATE.currentNode;
            return { ...state, currentNode };

        case ACTIONS.DRAG_BOARD:
            return { ...state, viewPos: { x: action.payload.x, y: action.payload.y } };

        case ACTIONS.DRAG_NODE:

            const node = { ...nodes[ action.payload.id ] };
            node.x = action.payload.x;
            node.y = action.payload.y;
            return { ...state, nodes: { ...nodes, [ action.payload.id ]: { ...node } } };

        case ACTIONS.DRAG_SET:
            return { ...state, dragging: action.payload };

        case ACTIONS.FORK:
            const revision = ( action.payload.board.revision + 1 );
            return { ...state, ...action.payload.board, name: `${ action.payload.board.name } (${ revision })`, isNew: false, revision, fork: { tokenId: action.payload.tokenId, name: action.payload.board.name } };

        case ACTIONS.NEW:
            return { ...INITIAL_STATE };

        case ACTIONS.NODE_ADD:

            const randomPositionOffset =  Math.floor( Math.random() * 50 ) + 1;

            nodes[ newId ] = { 
                ...action.payload.node, 
                id: newId, 
                x: state.viewPos.x + ( ( state.magnifications[ state.zoom ].width / 2 ) - 300 ) + randomPositionOffset, 
                y: state.viewPos.y + ( ( state.magnifications[ state.zoom ].height / 2 ) - 20 ) + randomPositionOffset
            };

            // auto connect node if it has a context
            if( action.payload.connectedTo ){
                const { connectedTo } = action.payload,
                connectionId = crypto.randomUUID();
                connections[ connectionId ] = [ newId, connectedTo ];
                
                nodes[ newId ].connections.push( connectionId );
                nodes[ connectedTo ].connections.push( connectionId );
            }

            if( isNew ) isNew = false;
            return { ...state, nodes, isNew, connections };

        case ACTIONS.NODE_DELETE:
            const orphans = [ ...nodes[ action.payload ].connections ];
            delete nodes[ action.payload ];

            // go through any connections associated with the node being deleted
            orphans.forEach( orphan => {

                // look for the orphan's other parent
                connections[ orphan ].forEach( parent => {

                    // if its not the parent we just killed and remove any recollection of the child
                    if( parent !== action.payload ){
                        const index = nodes[ parent ].connections.indexOf( orphan );
                        nodes[ parent ].connections.splice( index, 1 );
                    }

                });

                // kill the orphan
                delete connections[ orphan ];
            });
            return { ...state, nodes, connections, currentNode: {} };
            
        case ACTIONS.NODE_EVIDENCE:
            nodes[ action.payload.id ].evidence = action.payload.evidence;
            return { ...state, nodes }

        case ACTIONS.NODE_MODIFY:
            nodes[ action.payload.id ] = { ...action.payload };
            return { ...state, nodes, currentNode: {} };

        case ACTIONS.NODE_MENU:
            return { ...state, nodeContextMenu: action.payload };

        case ACTIONS.OPEN:
            return { ...state, ...action.payload, isNew: false };

        case ACTIONS.RESIZE:
            const proportions = [ ...MOVEMENT_SPEEDS ],
            height = action.payload?.height || window.innerHeight,
            width = action.payload?.width || window.innerWidth,
            magnifications = proportions.map( proportion => ({
                height: ( height * proportion ),
                width: ( width * proportion )
            }));

            return { ...state, magnifications };

        case ACTIONS.SAVE:

            const savableState = { ...state },
            d = new Date();

            // get rid of things that aren't crucial to be saved
            delete savableState.currentNode;
            delete savableState.magnifications;
            delete savableState.nodeContextMenu;
            
            const file = new File([ JSON.stringify( savableState ) ], `evidenceBoard-${ d.getTime() }.json`, {
                type: 'application/json',
            }),
            link = document.createElement('a'),
            url = URL.createObjectURL( file );
            
            link.href = url;
            link.download = file.name;
            document.body.appendChild( link );
            link.click();
            
            // cleanup
            document.body.removeChild( link );
            window.URL.revokeObjectURL( url );
                
            return { ...state, revision: ( state.revision + 1 ) };

        case ACTIONS.SET_NAME:
            return { ...state, name: action.payload };

        case WALKTHROUGH_END:

            for( let i in nodes ){
                const { walkthrough } = nodes[ i ];
                if( walkthrough ) delete nodes[ i ];
            }
            return { ...state, nodes };

        case ACTIONS.ZOOM:
            let direction = ( action.payload ) ? 1 : -1,
            index = ( state.zoom + direction ),
            zoom = ( index > -1 && index < state.magnifications.length ) ? index : state.zoom;
            return { ...state, zoom };

        default:
            return { ...state };
    }

}

export default reducer;